/* eslint-disable max-len */
export const REGULATORY_PREPROMPTS = {
	title: 'Regulatory Insights',
	description: 'Ask jurisdiction-specific compliance questions and receive instant, AI-generated insights. Just include your question and specify the jurisdiction for tailored responses. Disclaimer: This feature provides general informational guidance and does not constitute legal advice.',
	preprompts: [
		'What is the Travel Rule?',
		'What is a VASP or CASP?',
		'What is the Sunrise Issue in Travel Rule compliance?',
		'Do all businesses need to comply with the Travel Rule?',
		'How does the Travel Rule apply in European Union (EU)?',
		'How does the Travel Rule apply in United Kingdom (UK)?',
		'How does the Travel Rule apply in United States (USA)?',
		'How does the Travel Rule apply in United Arab Emirates (UAE)?',
		'How does the Travel Rule apply in Canada?',
	]
}
export const OSPREE_PREPROMPTS = {
	title: 'Get Started with Ospree',
	description: 'Maximize your experience with Ospree. Share your compliance goals or operational tasks to receive guided support—whether you\'re navigating the platform or designing custom API queries. ',
	preprompts: [
		'What API endpoints are available?',
		'How do I authenticate with the Ospree API?',
		'How can I submit a Travel Rule transfer?',
		'How should I handle transfers to self-hosted wallets?',
		'Write my first Travel Rule API request!',
	]
}

export const PREPROMPTS = {
	regulatory: REGULATORY_PREPROMPTS,
	ospree: OSPREE_PREPROMPTS
}
